import { isCouponTemplateSubtitleParams } from './utils';
export * from './loadLoyaltyCouponNames';
const getTypeFromCouponTemplate = ({ formatCurrency, t }, { coupon }) => {
    const { specification } = coupon;
    if (specification?.moneyOffAmount) {
        return t('loyalty-coupon-names.type.money-off', {
            amount: formatCurrency(specification.moneyOffAmount),
        });
    }
    else if (specification?.percentOffRate) {
        return t('loyalty-coupon-names.type.percentage-off', {
            amount: specification.percentOffRate,
        });
    }
    else if (specification?.freeShipping && specification.minimumSubtotal) {
        return t('loyalty-coupon-names.type.free-shipping-minimum', {
            amount: formatCurrency(specification.minimumSubtotal),
        });
    }
    else if (specification?.freeShipping) {
        return t('loyalty-coupon-names.type.free-shipping');
    }
    else if (specification?.fixedPriceAmount) {
        return t('loyalty-coupon-names.type.fixed-price', {
            amount: formatCurrency(specification.fixedPriceAmount),
        });
    }
    else if (specification?.buyXGetY) {
        return t('loyalty-coupon-names.type.buy-x-get-y', {
            x: specification.buyXGetY.x,
            y: specification.buyXGetY.y,
        });
    }
    else {
        return t('loyalty-coupon-names.type.fallback');
    }
};
const getTypeFromCouponReward = ({ t, formatCurrency }, { couponReward, config }) => {
    if (couponReward.fixedAmount) {
        const amount = config.amount;
        return t('loyalty-coupon-names.type.money-off', {
            amount: formatCurrency(amount),
        });
    }
    else if (couponReward.percentage) {
        const amount = config.percentage;
        return t('loyalty-coupon-names.type.percentage-off', { amount });
    }
    else if (couponReward.freeShipping && couponReward.minimumSubtotal) {
        return t('loyalty-coupon-names.type.free-shipping-minimum', {
            amount: formatCurrency(couponReward.minimumSubtotal),
        });
    }
    else if (couponReward.freeShipping) {
        return t('loyalty-coupon-names.type.free-shipping');
    }
    else {
        return t('loyalty-coupon-names.type.fallback');
    }
};
export const getType = (context, subtitleParams) => {
    if (isCouponTemplateSubtitleParams(subtitleParams)) {
        return getTypeFromCouponTemplate(context, subtitleParams);
    }
    else {
        return getTypeFromCouponReward(context, subtitleParams);
    }
};
//# sourceMappingURL=getType.js.map